export default __webpack_public_path__ + "static/media/img6.b6a3efdd.jpg";